"use strict";

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var solver_1 = require("../../../solver");

var axis_1 = require("../axis");

function getMatches(str) {
  var matches = [];
  var regex = /\(([^\(\)]*)\)/g;
  var match;

  while (match = regex.exec(str)) {
    matches.push(match[1]);
  }

  if (matches.length == 1) {
    return matches[0];
  }

  return matches;
}

exports.getMatches = getMatches;

var CrossFitter =
/*#__PURE__*/
function () {
  function CrossFitter(solver, mode) {
    _classCallCheck(this, CrossFitter);

    this.solver = solver;
    this.mode = mode;
    this.candidates = [];
  }

  _createClass(CrossFitter, [{
    key: "add",
    value: function add(src, dst) {
      return this.addComplex(src, [[1, dst]]);
    }
  }, {
    key: "addComplex",
    value: function addComplex(src, dst) {
      var dstBias = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.candidates.push([src, dst, dstBias]);
    }
  }, {
    key: "addConstraint",
    value: function addConstraint(w) {
      if (this.candidates.length == 0) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var candidate = _step.value;

          if (this.mode == "min") {
            this.solver.addSoftInequality(w, -candidate[2], [[1, candidate[0]]], candidate[1]);
          } else {
            this.solver.addSoftInequality(w, candidate[2], candidate[1], [[1, candidate[0]]]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);

  return CrossFitter;
}();

exports.CrossFitter = CrossFitter;

var DodgingFitters =
/*#__PURE__*/
function () {
  function DodgingFitters(solver) {
    _classCallCheck(this, DodgingFitters);

    this.xMin = new CrossFitter(solver, "min");
    this.yMin = new CrossFitter(solver, "min");
    this.xMax = new CrossFitter(solver, "max");
    this.yMax = new CrossFitter(solver, "max");
  }

  _createClass(DodgingFitters, [{
    key: "addConstraint",
    value: function addConstraint(w) {
      this.xMin.addConstraint(w);
      this.xMax.addConstraint(w);
      this.yMin.addConstraint(w);
      this.yMax.addConstraint(w);
    }
  }]);

  return DodgingFitters;
}();

exports.DodgingFitters = DodgingFitters;

var SublayoutGroup = function SublayoutGroup() {
  _classCallCheck(this, SublayoutGroup);
};

exports.SublayoutGroup = SublayoutGroup;

var Region2DConstraintBuilder =
/*#__PURE__*/
function () {
  function Region2DConstraintBuilder(plotSegment, config, x1Name, x2Name, y1Name, y2Name, solver, solverContext) {
    _classCallCheck(this, Region2DConstraintBuilder);

    this.plotSegment = plotSegment;
    this.config = config;
    this.x1Name = x1Name;
    this.x2Name = x2Name;
    this.y1Name = y1Name;
    this.y2Name = y2Name;
    this.solver = solver;
    this.solverContext = solverContext;
    this.terminology = config.terminology;
  }

  _createClass(Region2DConstraintBuilder, [{
    key: "getTableContext",
    value: function getTableContext() {
      return this.plotSegment.parent.dataflow.getTable(this.plotSegment.object.table);
    }
  }, {
    key: "getExpression",
    value: function getExpression(expr) {
      return this.plotSegment.parent.dataflow.cache.parse(expr);
    }
  }, {
    key: "groupMarksByCategories",
    value: function groupMarksByCategories(categories) {
      var _this = this;

      // Prepare categories
      var categoriesParsed = categories.map(function (c) {
        var imap = new Map();

        for (var i = 0; i < c.categories.length; i++) {
          imap.set(c.categories[i], i);
        }

        return {
          categories: c.categories,
          indexMap: imap,
          stride: 0,
          expression: _this.getExpression(c.expression)
        };
      });
      var k = 1;

      for (var i = categoriesParsed.length - 1; i >= 0; i--) {
        var c = categoriesParsed[i];
        c.stride = k;
        k *= c.categories.length;
      }

      var totalLength = k; // Gather result

      var result = new Array(totalLength);

      for (var _i = 0; _i < totalLength; _i++) {
        result[_i] = [];
      }

      var dateRowIndices = this.plotSegment.state.dataRowIndices;
      var table = this.getTableContext(); // Gather places

      for (var _i2 = 0; _i2 < dateRowIndices.length; _i2++) {
        var row = table.getGroupedContext(dateRowIndices[_i2]);
        var place = 0;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = categoriesParsed[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _c = _step2.value;

            var value = _c.expression.getStringValue(row);

            place += _c.indexMap.get(value) * _c.stride;
          } // Make sure the place is valid

        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (place == place) {
          result[place].push(_i2);
        }
      }

      return result;
    }
  }, {
    key: "orderMarkGroups",
    value: function orderMarkGroups(groups) {
      var order = this.plotSegment.object.properties.sublayout.order;
      var dateRowIndices = this.plotSegment.state.dataRowIndices;
      var table = this.getTableContext(); // Sort results

      if (order != null && order.expression) {
        var orderExpression = this.getExpression(order.expression);

        var compare = function compare(i, j) {
          var vi = orderExpression.getValue(table.getGroupedContext(dateRowIndices[i]));
          var vj = orderExpression.getValue(table.getGroupedContext(dateRowIndices[j]));

          if (vi < vj) {
            return -1;
          } else if (vi > vj) {
            return 1;
          } else {
            return 0;
          }
        };

        for (var i = 0; i < groups.length; i++) {
          groups[i].group.sort(compare);
        }
      }

      if (this.plotSegment.object.properties.sublayout.orderReversed) {
        for (var _i3 = 0; _i3 < groups.length; _i3++) {
          groups[_i3].group.reverse();
        }
      }

      return groups;
    }
    /** Make sure gapX correctly correspond to gapXRatio */

  }, {
    key: "gapX",
    value: function gapX(length, ratio) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var attrs = state.attributes;

      var _solver$attrs = solver.attrs(attrs, ["gapX", this.x1Name, this.x2Name]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 3),
          gapX = _solver$attrs2[0],
          x1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2];

      solver.addLinear(solver_1.ConstraintStrength.HARD, ratio * (props.marginX2 + props.marginX2), [[length - 1, gapX]], [[ratio, x2], [-ratio, x1]]);
    }
    /** Make sure gapY correctly correspond to gapYRatio */

  }, {
    key: "gapY",
    value: function gapY(length, ratio) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var attrs = state.attributes;

      var _solver$attrs3 = solver.attrs(attrs, ["gapY", this.y1Name, this.y2Name]),
          _solver$attrs4 = _slicedToArray(_solver$attrs3, 3),
          gapY = _solver$attrs4[0],
          y1 = _solver$attrs4[1],
          y2 = _solver$attrs4[2];

      solver.addLinear(solver_1.ConstraintStrength.HARD, ratio * (props.marginX2 + props.marginX2), [[length - 1, gapY]], [[ratio, y2], [-ratio, y1]]);
    }
    /** Map elements according to numerical/categorical mapping */

  }, {
    key: "numericalMapping",
    value: function numericalMapping(axis) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var attrs = state.attributes;
      var dataIndices = state.dataRowIndices;
      var table = this.getTableContext();

      switch (axis) {
        case "x":
          {
            var data = props.xData;

            if (data.type == "numerical") {
              var _solver$attrs5 = solver.attrs(attrs, [this.x1Name, this.x2Name]),
                  _solver$attrs6 = _slicedToArray(_solver$attrs5, 2),
                  x1 = _solver$attrs6[0],
                  x2 = _solver$attrs6[1];

              var expr = this.getExpression(data.expression);
              var interp = axis_1.getNumericalInterpolate(data);
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = state.glyphs.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _ref3 = _step3.value;

                  var _ref2 = _slicedToArray(_ref3, 2);

                  var index = _ref2[0];
                  var markState = _ref2[1];
                  var rowContext = table.getGroupedContext(dataIndices[index]);
                  var value = expr.getNumberValue(rowContext);
                  var t = interp(value);
                  solver.addLinear(solver_1.ConstraintStrength.HARD, (1 - t) * props.marginX1 - t * props.marginX2, [[1 - t, x1], [t, x2]], [[1, solver.attr(markState.attributes, "x")]]);
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }

            if (data.type == "categorical") {
              var _solver$attrs7 = solver.attrs(attrs, [this.x1Name, this.x2Name, "gapX"]),
                  _solver$attrs8 = _slicedToArray(_solver$attrs7, 3),
                  _x = _solver$attrs8[0],
                  _x2 = _solver$attrs8[1],
                  gapX = _solver$attrs8[2];

              var _expr = this.getExpression(data.expression);

              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = state.glyphs.entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var _ref6 = _step4.value;

                  var _ref5 = _slicedToArray(_ref6, 2);

                  var _index = _ref5[0];
                  var _markState = _ref5[1];

                  var _rowContext = table.getGroupedContext(dataIndices[_index]);

                  var _value = _expr.getStringValue(_rowContext);

                  this.gapX(data.categories.length, data.gapRatio);
                  var i = data.categories.indexOf(_value);
                  solver.addLinear(solver_1.ConstraintStrength.HARD, (data.categories.length - i - 0.5) * props.marginX1 - (i + 0.5) * props.marginX2, [[i + 0.5, _x2], [data.categories.length - i - 0.5, _x], [-data.categories.length / 2 + i + 0.5, gapX]], [[data.categories.length, solver.attr(_markState.attributes, "x")]]);
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            } // solver.addEquals(ConstraintWeight.HARD, x, x1);

          }
          break;

        case "y":
          {
            var _data = props.yData;

            if (_data.type == "numerical") {
              var _solver$attrs9 = solver.attrs(attrs, [this.y1Name, this.y2Name]),
                  _solver$attrs10 = _slicedToArray(_solver$attrs9, 2),
                  y1 = _solver$attrs10[0],
                  y2 = _solver$attrs10[1];

              var _expr2 = this.getExpression(_data.expression);

              var _interp = axis_1.getNumericalInterpolate(_data);

              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = state.glyphs.entries()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var _ref9 = _step5.value;

                  var _ref8 = _slicedToArray(_ref9, 2);

                  var _index2 = _ref8[0];
                  var _markState2 = _ref8[1];

                  var _rowContext2 = table.getGroupedContext(dataIndices[_index2]);

                  var _value2 = _expr2.getNumberValue(_rowContext2);

                  var _t = _interp(_value2);

                  solver.addLinear(solver_1.ConstraintStrength.HARD, (_t - 1) * props.marginY2 + _t * props.marginY1, [[1 - _t, y1], [_t, y2]], [[1, solver.attr(_markState2.attributes, "y")]]);
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }

            if (_data.type == "categorical") {
              var _solver$attrs11 = solver.attrs(attrs, [this.y1Name, this.y2Name, "gapY"]),
                  _solver$attrs12 = _slicedToArray(_solver$attrs11, 3),
                  _y = _solver$attrs12[0],
                  _y2 = _solver$attrs12[1],
                  gapY = _solver$attrs12[2];

              var _expr3 = this.getExpression(_data.expression);

              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = state.glyphs.entries()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var _ref12 = _step6.value;

                  var _ref11 = _slicedToArray(_ref12, 2);

                  var _index3 = _ref11[0];
                  var _markState3 = _ref11[1];

                  var _rowContext3 = table.getGroupedContext(dataIndices[_index3]);

                  var _value3 = _expr3.getStringValue(_rowContext3);

                  this.gapY(_data.categories.length, _data.gapRatio);

                  var _i4 = _data.categories.indexOf(_value3);

                  solver.addLinear(solver_1.ConstraintStrength.HARD, (_data.categories.length - _i4 - 0.5) * props.marginY1 - (_i4 + 0.5) * props.marginY2, [[_i4 + 0.5, _y2], [_data.categories.length - _i4 - 0.5, _y], [-_data.categories.length / 2 + _i4 + 0.5, gapY]], [[_data.categories.length, solver.attr(_markState3.attributes, "y")]]);
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            } // solver.addEquals(ConstraintWeight.HARD, y, y2);

          }
      }
    }
  }, {
    key: "groupMarksByCategoricalMapping",
    value: function groupMarksByCategoricalMapping(axis) {
      var props = this.plotSegment.object.properties;

      switch (axis) {
        case "x":
          {
            var data = props.xData;
            return this.groupMarksByCategories([{
              categories: data.categories,
              expression: data.expression
            }]);
          }

        case "y":
          {
            var _data2 = props.yData;
            return this.groupMarksByCategories([{
              categories: _data2.categories,
              expression: _data2.expression
            }]);
          }

        case "xy":
          {
            var xData = props.xData;
            var yData = props.yData;
            return this.groupMarksByCategories([{
              categories: xData.categories,
              expression: xData.expression
            }, {
              categories: yData.categories,
              expression: yData.expression
            }]);
          }
      }
    }
  }, {
    key: "categoricalMapping",
    value: function categoricalMapping(axis, sublayoutContext) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var attrs = state.attributes;
      var props = this.plotSegment.object.properties;
      var categoryMarks = this.groupMarksByCategoricalMapping(axis);

      switch (axis) {
        case "x":
          {
            var data = props.xData;

            var _solver$attrs13 = solver.attrs(attrs, [this.x1Name, this.x2Name, this.y1Name, this.y2Name]),
                _solver$attrs14 = _slicedToArray(_solver$attrs13, 4),
                x1 = _solver$attrs14[0],
                x2 = _solver$attrs14[1],
                y1 = _solver$attrs14[2],
                y2 = _solver$attrs14[3];

            var _axis = axis_1.getCategoricalAxis(data, this.config.xAxisPrePostGap, false);

            var sublayoutGroups = [];

            for (var cindex = 0; cindex < data.categories.length; cindex++) {
              var _axis$ranges$cindex = _slicedToArray(_axis.ranges[cindex], 2),
                  t1 = _axis$ranges$cindex[0],
                  t2 = _axis$ranges$cindex[1];

              var vx1Expr = [[t1, x2], [1 - t1, x1]];
              var vx2Expr = [[t2, x2], [1 - t2, x1]];
              var vx1 = solver.attr({
                value: solver.getLinear.apply(solver, vx1Expr)
              }, "value", {
                edit: true
              });
              var vx2 = solver.attr({
                value: solver.getLinear.apply(solver, vx2Expr)
              }, "value", {
                edit: true
              });
              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, vx1Expr, [[1, vx1]]);
              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, vx2Expr, [[1, vx2]]);
              sublayoutGroups.push({
                group: categoryMarks[cindex],
                x1: vx1,
                y1: y1,
                x2: vx2,
                y2: y2
              });
            }

            this.applySublayout(sublayoutGroups, "x", sublayoutContext);
          }
          break;

        case "y":
          {
            var _data3 = props.yData;

            var _solver$attrs15 = solver.attrs(attrs, [this.x1Name, this.x2Name, this.y1Name, this.y2Name]),
                _solver$attrs16 = _slicedToArray(_solver$attrs15, 4),
                _x3 = _solver$attrs16[0],
                _x4 = _solver$attrs16[1],
                _y3 = _solver$attrs16[2],
                _y4 = _solver$attrs16[3];

            var _axis2 = axis_1.getCategoricalAxis(_data3, this.config.yAxisPrePostGap, true);

            var _sublayoutGroups = [];

            for (var _cindex = 0; _cindex < _data3.categories.length; _cindex++) {
              var _axis2$ranges$_cindex = _slicedToArray(_axis2.ranges[_cindex], 2),
                  t1 = _axis2$ranges$_cindex[0],
                  t2 = _axis2$ranges$_cindex[1];

              var vy1Expr = [[t1, _y4], [1 - t1, _y3]];
              var vy2Expr = [[t2, _y4], [1 - t2, _y3]];
              var vy1 = solver.attr({
                value: solver.getLinear.apply(solver, vy1Expr)
              }, "value", {
                edit: true
              });
              var vy2 = solver.attr({
                value: solver.getLinear.apply(solver, vy2Expr)
              }, "value", {
                edit: true
              });
              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, vy1Expr, [[1, vy1]]);
              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, vy2Expr, [[1, vy2]]);

              _sublayoutGroups.push({
                group: categoryMarks[_cindex],
                x1: _x3,
                y1: vy1,
                x2: _x4,
                y2: vy2
              });
            }

            this.applySublayout(_sublayoutGroups, "y", sublayoutContext);
          }
          break;

        case "xy":
          {
            var xData = props.xData;
            var yData = props.yData;

            var _solver$attrs17 = solver.attrs(attrs, [this.x1Name, this.x2Name, this.y1Name, this.y2Name]),
                _solver$attrs18 = _slicedToArray(_solver$attrs17, 4),
                _x5 = _solver$attrs18[0],
                _x6 = _solver$attrs18[1],
                _y5 = _solver$attrs18[2],
                _y6 = _solver$attrs18[3];

            var xAxis = axis_1.getCategoricalAxis(xData, this.config.xAxisPrePostGap, false);
            var yAxis = axis_1.getCategoricalAxis(yData, this.config.yAxisPrePostGap, true);
            var _sublayoutGroups2 = [];

            for (var yIndex = 0; yIndex < yData.categories.length; yIndex++) {
              var _yAxis$ranges$yIndex = _slicedToArray(yAxis.ranges[yIndex], 2),
                  ty1 = _yAxis$ranges$yIndex[0],
                  ty2 = _yAxis$ranges$yIndex[1];

              for (var xIndex = 0; xIndex < xData.categories.length; xIndex++) {
                var _xAxis$ranges$xIndex = _slicedToArray(xAxis.ranges[xIndex], 2),
                    tx1 = _xAxis$ranges$xIndex[0],
                    tx2 = _xAxis$ranges$xIndex[1];

                var _vx1Expr = [[tx1, _x6], [1 - tx1, _x5]];
                var _vx2Expr = [[tx2, _x6], [1 - tx2, _x5]];
                var _vy1Expr = [[ty1, _y6], [1 - ty1, _y5]];
                var _vy2Expr = [[ty2, _y6], [1 - ty2, _y5]];

                var _vx = solver.attr({
                  value: solver.getLinear.apply(solver, _vx1Expr)
                }, "value", {
                  edit: true
                });

                var _vx2 = solver.attr({
                  value: solver.getLinear.apply(solver, _vx2Expr)
                }, "value", {
                  edit: true
                });

                var _vy = solver.attr({
                  value: solver.getLinear.apply(solver, _vy1Expr)
                }, "value", {
                  edit: true
                });

                var _vy2 = solver.attr({
                  value: solver.getLinear.apply(solver, _vy2Expr)
                }, "value", {
                  edit: true
                });

                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, _vx1Expr, [[1, _vx]]);
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, _vx2Expr, [[1, _vx2]]);
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, _vy1Expr, [[1, _vy]]);
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, _vy2Expr, [[1, _vy2]]);

                _sublayoutGroups2.push({
                  group: categoryMarks[xIndex * yData.categories.length + yIndex],
                  x1: _vx,
                  y1: _vy,
                  x2: _vx2,
                  y2: _vy2
                });
              }
            }

            this.applySublayout(_sublayoutGroups2, "xy", sublayoutContext);
          }
          break;
      }
    }
  }, {
    key: "categoricalHandles",
    value: function categoricalHandles(axis, sublayout) {
      var handles = [];
      var props = this.plotSegment.object.properties;
      var x1 = this.plotSegment.state.attributes[this.x1Name];
      var y1 = this.plotSegment.state.attributes[this.y1Name];
      var x2 = this.plotSegment.state.attributes[this.x2Name];
      var y2 = this.plotSegment.state.attributes[this.y2Name]; // We are using sublayouts here

      if (sublayout) {
        var categoryMarks = this.groupMarksByCategoricalMapping(axis);
        var xAxis = axis == "x" || axis == "xy" ? axis_1.getCategoricalAxis(props.xData, this.config.xAxisPrePostGap, false) : null;
        var yAxis = axis == "y" || axis == "xy" ? axis_1.getCategoricalAxis(props.yData, this.config.yAxisPrePostGap, true) : null;
        handles = handles.concat(this.sublayoutHandles(categoryMarks.map(function (x, i) {
          var ix = i,
              iy = i;

          if (axis == "xy") {
            ix = i % xAxis.ranges.length;
            iy = Math.floor(i / xAxis.ranges.length);
          }

          return {
            group: x,
            x1: xAxis ? xAxis.ranges[ix][0] * (x2 - x1) + x1 : x1,
            y1: yAxis ? yAxis.ranges[iy][0] * (y2 - y1) + y1 : y1,
            x2: xAxis ? xAxis.ranges[ix][1] * (x2 - x1) + x1 : x2,
            y2: yAxis ? yAxis.ranges[iy][1] * (y2 - y1) + y1 : y2
          };
        }), false, false));
      }

      if (axis == "x" || axis == "xy") {
        var data = props.xData;

        var _axis3 = axis_1.getCategoricalAxis(data, this.config.xAxisPrePostGap, false);

        for (var i = 0; i < _axis3.ranges.length - 1; i++) {
          var p1 = _axis3.ranges[i][1];
          handles.push({
            type: "gap",
            gap: {
              property: {
                property: "xData",
                field: "gapRatio"
              },
              axis: "x",
              reference: p1 * (x2 - x1) + x1,
              value: data.gapRatio,
              scale: _axis3.gapScale * (x2 - x1),
              span: [y1, y2]
            }
          });
        }
      }

      if (axis == "y" || axis == "xy") {
        var _data4 = props.yData;

        var _axis4 = axis_1.getCategoricalAxis(_data4, this.config.yAxisPrePostGap, true);

        for (var _i5 = 0; _i5 < _axis4.ranges.length - 1; _i5++) {
          var _p = _axis4.ranges[_i5][1];
          handles.push({
            type: "gap",
            gap: {
              property: {
                property: "yData",
                field: "gapRatio"
              },
              axis: "y",
              reference: _p * (y2 - y1) + y1,
              value: _data4.gapRatio,
              scale: _axis4.gapScale * (y2 - y1),
              span: [x1, x2]
            }
          });
        }
      }

      return handles;
    }
  }, {
    key: "stacking",
    value: function stacking(axis) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var attrs = state.attributes;
      var dataIndices = state.dataRowIndices;

      var _solver$attrs19 = solver.attrs(attrs, [this.x1Name, this.x2Name, this.y1Name, this.y2Name]),
          _solver$attrs20 = _slicedToArray(_solver$attrs19, 4),
          x1 = _solver$attrs20[0],
          x2 = _solver$attrs20[1],
          y1 = _solver$attrs20[2],
          y2 = _solver$attrs20[3];

      var count = dataIndices.length;
      var doStack = count <= 36;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = state.glyphs.entries()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref15 = _step7.value;

          var _ref14 = _slicedToArray(_ref15, 2);

          var index = _ref14[0];
          var markState = _ref14[1];

          switch (axis) {
            case "x":
              {
                var _solver$attrs21 = solver.attrs(attrs, ["gapX"]),
                    _solver$attrs22 = _slicedToArray(_solver$attrs21, 1),
                    gapX = _solver$attrs22[0];

                if (doStack) {
                  if (index > 0) {
                    var x2Prev = solver.attr(state.glyphs[index - 1].attributes, "x2");
                    var x1This = solver.attr(state.glyphs[index].attributes, "x1");
                    solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x2Prev], [-1, x1This], [1, gapX]]);
                  }

                  if (index == 0) {
                    var _x1This = solver.attr(state.glyphs[index].attributes, "x1"); // solver.addEquals(ConstraintWeight.HARD, x1, x1This);


                    solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x1]], [[1, _x1This]]);
                  }

                  if (index == state.glyphs.length - 1) {
                    var x2This = solver.attr(state.glyphs[index].attributes, "x2");
                    solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x2]], [[1, x2This]]);
                  }
                } else {
                  var t = (index + 0.5) / count;
                  solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1 - t, x1], [t, x2]], [[1, solver.attr(markState.attributes, "x")]]);
                  solver.addLinear(solver_1.ConstraintStrength.WEAK, 0, [[1, x2], [-1, x1]], [[count, solver.attr(markState.attributes, "width")], [count - 1, gapX]]);
                }
              }
              break;

            case "y":
              {
                var _solver$attrs23 = solver.attrs(attrs, ["gapY"]),
                    _solver$attrs24 = _slicedToArray(_solver$attrs23, 1),
                    gapY = _solver$attrs24[0];

                if (doStack) {
                  if (index > 0) {
                    var y2Prev = solver.attr(state.glyphs[index - 1].attributes, "y2");
                    var y1This = solver.attr(state.glyphs[index].attributes, "y1");
                    solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y2Prev], [-1, y1This], [1, gapY]]);
                  }

                  if (index == 0) {
                    var _y1This = solver.attr(state.glyphs[index].attributes, "y1");

                    solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y1]], [[1, _y1This]]);
                  }

                  if (index == state.glyphs.length - 1) {
                    var y2This = solver.attr(state.glyphs[index].attributes, "y2");
                    solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y2]], [[1, y2This]]);
                  }
                } else {
                  var _t2 = (index + 0.5) / count;

                  solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1 - _t2, y2], [_t2, y1]], [[1, solver.attr(markState.attributes, "y")]]);
                  solver.addLinear(solver_1.ConstraintStrength.WEAK, 0, [[1, y2], [-1, y1]], [[count, solver.attr(markState.attributes, "height")], [count - 1, gapY]]);
                }
              }
              break;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      switch (axis) {
        case "x":
          {
            this.gapX(count, this.plotSegment.object.properties.xData.gapRatio);
          }
          break;

        case "y":
          {
            this.gapY(count, this.plotSegment.object.properties.yData.gapRatio);
          }
          break;
      }
    }
  }, {
    key: "fitGroups",
    value: function fitGroups(groups, axis) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var fitters = new DodgingFitters(solver);
      var alignment = props.sublayout.align;
      groups.forEach(function (group) {
        var markStates = group.group.map(function (index) {
          return state.glyphs[index];
        });
        var x1 = group.x1,
            y1 = group.y1,
            x2 = group.x2,
            y2 = group.y2;

        for (var index = 0; index < markStates.length; index++) {
          var m1 = markStates[index];

          if (axis == "x" || axis == "xy") {
            if (alignment.x == "start") {
              solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(m1.attributes, "x1"), x1);
            } else {
              fitters.xMin.add(solver.attr(m1.attributes, "x1"), x1);
            }

            if (alignment.x == "end") {
              solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(m1.attributes, "x2"), x2);
            } else {
              fitters.xMax.add(solver.attr(m1.attributes, "x2"), x2);
            }

            if (alignment.x == "middle") {
              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(m1.attributes, "x1")], [1, solver.attr(m1.attributes, "x2")]], [[1, x1], [1, x2]]);
            }
          }

          if (axis == "y" || axis == "xy") {
            if (alignment.y == "start") {
              solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(m1.attributes, "y1"), y1);
            } else {
              fitters.yMin.add(solver.attr(m1.attributes, "y1"), y1);
            }

            if (alignment.y == "end") {
              solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(m1.attributes, "y2"), y2);
            } else {
              fitters.yMax.add(solver.attr(m1.attributes, "y2"), y2);
            }

            if (alignment.y == "middle") {
              solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(m1.attributes, "y1")], [1, solver.attr(m1.attributes, "y2")]], [[1, y1], [1, y2]]);
            }
          }
        }
      });
      fitters.addConstraint(solver_1.ConstraintStrength.MEDIUM);
    }
  }, {
    key: "applySublayout",
    value: function applySublayout(groups, axis, context) {
      if (!context || context.mode == "disabled") {
        this.fitGroups(groups, axis);
      } else {
        this.orderMarkGroups(groups);
        var props = this.plotSegment.object.properties;

        if (context.mode == "x-only" || context.mode == "y-only") {
          if (props.sublayout.type == "packing") {
            this.sublayoutPacking(groups, context.mode == "x-only" ? "x" : "y");
          } else {
            this.fitGroups(groups, axis);
          }
        } else {
          if (props.sublayout.type == "overlap") {
            this.fitGroups(groups, "xy");
          }

          if (props.sublayout.type == "dodge-x") {
            this.sublayoutDodging(groups, "x", context.xAxisPrePostGap);
          }

          if (props.sublayout.type == "dodge-y") {
            this.sublayoutDodging(groups, "y", context.yAxisPrePostGap);
          }

          if (props.sublayout.type == "grid") {
            this.sublayoutGrid(groups);
          }

          if (props.sublayout.type == "packing") {
            this.sublayoutPacking(groups);
          }
        }
      }
    }
  }, {
    key: "sublayoutDodging",
    value: function sublayoutDodging(groups, direction, enablePrePostGap) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var dataIndices = state.dataRowIndices;
      var fitters = new DodgingFitters(solver);
      var alignment = props.sublayout.align;
      var maxCount = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = groups[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var g = _step8.value;
          maxCount = Math.max(maxCount, g.group.length);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var dodgeGapRatio = 0;
      var dodgeGapOffset = 0;

      if (!enablePrePostGap) {
        dodgeGapRatio = direction == "x" ? props.sublayout.ratioX / (maxCount - 1) : props.sublayout.ratioY / (maxCount - 1);
        dodgeGapOffset = 0;
      } else {
        dodgeGapRatio = direction == "x" ? props.sublayout.ratioX / maxCount : props.sublayout.ratioY / maxCount;
        dodgeGapOffset = dodgeGapRatio / 2;
      }

      groups.forEach(function (group) {
        var markStates = group.group.map(function (index) {
          return state.glyphs[index];
        });
        var x1 = group.x1,
            y1 = group.y1,
            x2 = group.x2,
            y2 = group.y2;
        var count = markStates.length; // If nothing there, skip

        if (count == 0) {
          return;
        }

        for (var index = 0; index < markStates.length; index++) {
          var _m = markStates[index];

          if (index > 0) {
            var m0 = markStates[index - 1];

            switch (direction) {
              case "x":
                {
                  solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[dodgeGapRatio, x2], [-dodgeGapRatio, x1], [1, solver.attr(m0.attributes, "x2")], [-1, solver.attr(_m.attributes, "x1")]]);
                }
                break;

              case "y":
                {
                  solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[dodgeGapRatio, y2], [-dodgeGapRatio, y1], [1, solver.attr(m0.attributes, "y2")], [-1, solver.attr(_m.attributes, "y1")]]);
                }
                break;
            }
          }

          switch (direction) {
            case "x":
              {
                if (alignment.y == "start") {
                  solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(_m.attributes, "y1"), y1);
                } else {
                  fitters.yMin.add(solver.attr(_m.attributes, "y1"), y1);
                }

                if (alignment.y == "end") {
                  solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(_m.attributes, "y2"), y2);
                } else {
                  fitters.yMax.add(solver.attr(_m.attributes, "y2"), y2);
                }

                if (alignment.y == "middle") {
                  solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_m.attributes, "y1")], [1, solver.attr(_m.attributes, "y2")]], [[1, y1], [1, y2]]);
                }
              }
              break;

            case "y":
              {
                if (alignment.x == "start") {
                  solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(_m.attributes, "x1"), x1);
                } else {
                  fitters.xMin.add(solver.attr(_m.attributes, "x1"), x1);
                }

                if (alignment.x == "end") {
                  solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(_m.attributes, "x2"), x2);
                } else {
                  fitters.xMax.add(solver.attr(_m.attributes, "x2"), x2);
                }

                if (alignment.x == "middle") {
                  solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_m.attributes, "x1")], [1, solver.attr(_m.attributes, "x2")]], [[1, x1], [1, x2]]);
                }
              }
              break;
          }
        }

        var m1 = markStates[0];
        var mN = markStates[markStates.length - 1];

        switch (direction) {
          case "x":
            {
              var x1WithGap = [[1, x1], [dodgeGapOffset, x2], [-dodgeGapOffset, x1]];
              var x2WithGap = [[1, x2], [dodgeGapOffset, x1], [-dodgeGapOffset, x2]];

              if (alignment.x == "start") {
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(m1.attributes, "x1")]], x1WithGap);
              } else {
                fitters.xMin.addComplex(solver.attr(m1.attributes, "x1"), x1WithGap);
              }

              if (alignment.x == "end") {
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(mN.attributes, "x2")]], x2WithGap);
              } else {
                fitters.xMax.addComplex(solver.attr(mN.attributes, "x2"), x2WithGap);
              }

              if (alignment.x == "middle") {
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(m1.attributes, "x1")], [1, solver.attr(mN.attributes, "x2")]], [[1, x1], [1, x2]]);
              }
            }
            break;

          case "y":
            {
              var y1WithGap = [[1, y1], [dodgeGapOffset, y2], [-dodgeGapOffset, y1]];
              var y2WithGap = [[1, y2], [dodgeGapOffset, y1], [-dodgeGapOffset, y2]];

              if (alignment.y == "start") {
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(m1.attributes, "y1")]], y1WithGap);
              } else {
                fitters.yMin.addComplex(solver.attr(m1.attributes, "y1"), y1WithGap);
              }

              if (alignment.y == "end") {
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(mN.attributes, "y2")]], y2WithGap);
              } else {
                fitters.yMax.addComplex(solver.attr(mN.attributes, "y2"), y2WithGap);
              }

              if (alignment.y == "middle") {
                solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(m1.attributes, "y1")], [1, solver.attr(mN.attributes, "y2")]], [[1, y1], [1, y2]]);
              }
            }
            break;
        }
      });
      fitters.addConstraint(solver_1.ConstraintStrength.MEDIUM);
    }
  }, {
    key: "getGlyphPreSolveAttributes",
    value: function getGlyphPreSolveAttributes(rowIndices) {
      var attrs = this.solverContext.getGlyphAttributes(this.plotSegment.object.glyph, this.plotSegment.object.table, rowIndices);
      return attrs;
    }
  }, {
    key: "sublayoutGrid",
    value: function sublayoutGrid(groups, directionOverride) {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var direction = props.sublayout.grid.direction;

      if (directionOverride != null) {
        direction = directionOverride;
      }

      var alignX = props.sublayout.align.x;
      var alignY = props.sublayout.align.y;
      var xMinFitter = new CrossFitter(solver, "min");
      var xMaxFitter = new CrossFitter(solver, "max");
      var yMinFitter = new CrossFitter(solver, "min");
      var yMaxFitter = new CrossFitter(solver, "max");
      var maxCount = 0;
      groups.forEach(function (group) {
        if (maxCount < group.group.length) {
          maxCount = group.group.length;
        }
      });
      var xCount, yCount; // Determine xCount and yCount, aka., the number of divisions on each axis

      switch (direction) {
        case "x":
          {
            if (props.sublayout.grid.xCount != null) {
              xCount = props.sublayout.grid.xCount;
              yCount = Math.ceil(maxCount / xCount);
            } else {
              xCount = Math.ceil(Math.sqrt(maxCount));
              yCount = Math.ceil(maxCount / xCount);
            }
          }
          break;

        case "y":
          {
            if (props.sublayout.grid.yCount != null) {
              yCount = props.sublayout.grid.yCount;
              xCount = Math.ceil(maxCount / yCount);
            } else {
              yCount = Math.ceil(Math.sqrt(maxCount));
              xCount = Math.ceil(maxCount / yCount);
            }
          }
          break;

        case "x1":
          {
            xCount = maxCount;
            yCount = 1;
          }
          break;

        case "y1":
          {
            yCount = maxCount;
            xCount = 1;
          }
          break;
      }

      var gapRatioX = xCount > 1 ? props.sublayout.ratioX / (xCount - 1) : 0;
      var gapRatioY = yCount > 1 ? props.sublayout.ratioY / (yCount - 1) : 0;
      groups.forEach(function (group) {
        var markStates = group.group.map(function (index) {
          return state.glyphs[index];
        });
        var x1 = group.x1,
            y1 = group.y1,
            x2 = group.x2,
            y2 = group.y2;
        var xMax, yMax;

        if (direction == "x" || direction == "x1") {
          xMax = Math.min(markStates.length, xCount);
          yMax = Math.ceil(markStates.length / xCount);
        } else {
          yMax = Math.min(markStates.length, yCount);
          xMax = Math.ceil(markStates.length / yCount);
        } // Constraint glyphs


        for (var i = 0; i < markStates.length; i++) {
          var xi = void 0,
              yi = void 0;

          if (direction == "x" || direction == "x1") {
            xi = i % xCount;

            if (alignY == "start") {
              xi = xMax - 1 - (markStates.length - 1 - i) % xCount;
              yi = Math.floor((markStates.length - 1 - i) / xCount);
            } else {
              yi = yMax - 1 - Math.floor(i / xCount);
            }
          } else {
            yi = yMax - 1 - i % yCount;
            xi = Math.floor(i / yCount);

            if (alignX == "end") {
              yi = (markStates.length - 1 - i) % yCount;
              xi = xMax - 1 - Math.floor((markStates.length - 1 - i) / yCount);
            }
          } // Adjust xi, yi based on alignment settings


          if (alignX == "end") {
            xi = xi + xCount - xMax;
          }

          if (alignX == "middle") {
            xi = xi + (xCount - xMax) / 2;
          }

          if (alignY == "end") {
            yi = yi + yCount - yMax;
          }

          if (alignY == "middle") {
            yi = yi + (yCount - yMax) / 2;
          }

          var cellX1 = [[xi / xCount * (1 + gapRatioX), x2], [1 - xi / xCount * (1 + gapRatioX), x1]];
          var cellX2 = [[(xi + 1) / xCount * (1 + gapRatioX) - gapRatioX, x2], [1 - (xi + 1) / xCount * (1 + gapRatioX) + gapRatioX, x1]];
          var cellY1 = [[yi / yCount * (1 + gapRatioY), y2], [1 - yi / yCount * (1 + gapRatioY), y1]];
          var cellY2 = [[(yi + 1) / yCount * (1 + gapRatioY) - gapRatioY, y2], [1 - (yi + 1) / yCount * (1 + gapRatioY) + gapRatioY, y1]];
          var _state = markStates[i];

          if (alignX == "start") {
            solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_state.attributes, "x1")]], cellX1);
          } else {
            xMinFitter.addComplex(solver.attr(_state.attributes, "x1"), cellX1);
          }

          if (alignX == "end") {
            solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_state.attributes, "x2")]], cellX2);
          } else {
            xMaxFitter.addComplex(solver.attr(_state.attributes, "x2"), cellX2);
          }

          if (alignX == "middle") {
            solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_state.attributes, "x1")], [1, solver.attr(_state.attributes, "x2")]], cellX1.concat(cellX2));
          }

          if (alignY == "start") {
            solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_state.attributes, "y1")]], cellY1);
          } else {
            yMinFitter.addComplex(solver.attr(_state.attributes, "y1"), cellY1);
          }

          if (alignY == "end") {
            solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_state.attributes, "y2")]], cellY2);
          } else {
            yMaxFitter.addComplex(solver.attr(_state.attributes, "y2"), cellY2);
          }

          if (alignY == "middle") {
            solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, solver.attr(_state.attributes, "y1")], [1, solver.attr(_state.attributes, "y2")]], cellY1.concat(cellY2));
          }
        }
      });
      xMinFitter.addConstraint(solver_1.ConstraintStrength.MEDIUM);
      xMaxFitter.addConstraint(solver_1.ConstraintStrength.MEDIUM);
      yMinFitter.addConstraint(solver_1.ConstraintStrength.MEDIUM);
      yMaxFitter.addConstraint(solver_1.ConstraintStrength.MEDIUM);
    }
  }, {
    key: "sublayoutHandles",
    value: function sublayoutHandles(groups, enablePrePostGapX, enablePrePostGapY) {
      this.orderMarkGroups(groups);
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var handles = [];
      var maxCount = 0;
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = groups[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var g = _step9.value;
          maxCount = Math.max(maxCount, g.group.length);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      if (props.sublayout.type == "dodge-x") {
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = groups[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var group = _step10.value;

            for (var i = 0; i < group.group.length - 1; i++) {
              var state1 = state.glyphs[group.group[i]];
              var state2 = state.glyphs[group.group[i + 1]];
              var p1 = state1.attributes.x2;
              var minY = Math.min(state1.attributes.y1, state1.attributes.y2, state2.attributes.y1, state2.attributes.y2);
              var maxY = Math.max(state1.attributes.y1, state1.attributes.y2, state2.attributes.y1, state2.attributes.y2);
              handles.push({
                type: "gap",
                gap: {
                  axis: "x",
                  property: {
                    property: "sublayout",
                    field: "ratioX"
                  },
                  reference: p1,
                  value: props.sublayout.ratioX,
                  scale: 1 / (enablePrePostGapX ? maxCount : maxCount - 1) * (group.x2 - group.x1),
                  span: [minY, maxY]
                }
              });
            }
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }
      }

      if (props.sublayout.type == "dodge-y") {
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = groups[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _group = _step11.value;

            for (var _i6 = 0; _i6 < _group.group.length - 1; _i6++) {
              var _state2 = state.glyphs[_group.group[_i6]];
              var _state3 = state.glyphs[_group.group[_i6 + 1]];
              var _p2 = _state2.attributes.y2;
              var minX = Math.min(_state2.attributes.x1, _state2.attributes.x2, _state3.attributes.x1, _state3.attributes.x2);
              var maxX = Math.max(_state2.attributes.x1, _state2.attributes.x2, _state3.attributes.x1, _state3.attributes.x2);
              handles.push({
                type: "gap",
                gap: {
                  axis: "y",
                  property: {
                    property: "sublayout",
                    field: "ratioY"
                  },
                  reference: _p2,
                  value: props.sublayout.ratioY,
                  scale: 1 / (enablePrePostGapY ? maxCount : maxCount - 1) * (_group.y2 - _group.y1),
                  span: [minX, maxX]
                }
              });
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }
      }

      if (props.sublayout.type == "grid") {// TODO: implement grid sublayout handles
      }

      return handles;
    }
  }, {
    key: "sublayoutPacking",
    value: function sublayoutPacking(groups, axisOnly) {
      var _this2 = this;

      var solver = this.solver;
      var state = this.plotSegment.state;
      groups.forEach(function (group) {
        var markStates = group.group.map(function (index) {
          return state.glyphs[index];
        });
        var x1 = group.x1,
            y1 = group.y1,
            x2 = group.x2,
            y2 = group.y2;
        var centerState = {
          cx: 0,
          cy: 0
        };
        var cx = solver.attr(centerState, "cx", {
          edit: true
        });
        var cy = solver.attr(centerState, "cy", {
          edit: true
        });
        solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cx]], [[1, x1], [1, x2]]);
        solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cy]], [[1, y1], [1, y2]]);
        var points = markStates.map(function (state) {
          var radius = 0;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = state.marks[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var e = _step12.value;

              if (e.attributes.size != null) {
                radius = Math.max(radius, Math.sqrt(e.attributes.size / Math.PI));
              } else {
                var w = e.attributes.width;
                var h = e.attributes.height;

                if (w != null && h != null) {
                  radius = Math.max(radius, Math.sqrt(w * w + h * h) / 2);
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          if (radius == 0) {
            radius = 5;
          }

          return [solver.attr(state.attributes, "x"), solver.attr(state.attributes, "y"), radius];
        });
        solver.addPlugin(new solver_1.ConstraintPlugins.PackingPlugin(solver, cx, cy, points, axisOnly, _this2.config.getXYScale));
      });
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var state = this.plotSegment.state;
      var props = this.plotSegment.object.properties;
      var xMode = props.xData ? props.xData.type : "null";
      var yMode = props.yData ? props.yData.type : "null";
      var handles = [];

      switch (xMode) {
        case "null":
          {
            switch (yMode) {
              case "null":
                {
                  handles = handles.concat(this.sublayoutHandles([{
                    x1: state.attributes[this.x1Name],
                    y1: state.attributes[this.y1Name],
                    x2: state.attributes[this.x2Name],
                    y2: state.attributes[this.y2Name],
                    group: state.dataRowIndices.map(function (x, i) {
                      return i;
                    })
                  }], this.config.xAxisPrePostGap, this.config.yAxisPrePostGap));
                }
                break;

              case "numerical":
                {}
                break;

              case "categorical":
                {
                  handles = handles.concat(this.categoricalHandles("y", true));
                }
                break;
            }
          }
          break;

        case "numerical":
          {
            switch (yMode) {
              case "null":
                {}
                break;

              case "numerical":
                {}
                break;

              case "categorical":
                {
                  handles = handles.concat(this.categoricalHandles("y", false));
                }
                break;
            }
          }
          break;

        case "categorical":
          {
            switch (yMode) {
              case "null":
                {
                  handles = handles.concat(this.categoricalHandles("x", true));
                }
                break;

              case "numerical":
                {
                  handles = handles.concat(this.categoricalHandles("x", false));
                }
                break;

              case "categorical":
                {
                  handles = handles.concat(this.categoricalHandles("xy", true));
                }
                break;
            }
          }
          break;
      }

      return handles;
    }
  }, {
    key: "build",
    value: function build() {
      var solver = this.solver;
      var state = this.plotSegment.state;
      var attrs = state.attributes;
      var props = this.plotSegment.object.properties;
      var xMode = props.xData ? props.xData.type : "null";
      var yMode = props.yData ? props.yData.type : "null";

      switch (xMode) {
        case "null":
          {
            switch (yMode) {
              case "null":
                {
                  // null, null
                  this.applySublayout([{
                    x1: solver.attr(attrs, this.x1Name),
                    y1: solver.attr(attrs, this.y1Name),
                    x2: solver.attr(attrs, this.x2Name),
                    y2: solver.attr(attrs, this.y2Name),
                    group: state.dataRowIndices.map(function (x, i) {
                      return i;
                    })
                  }], "xy", {
                    mode: "default",
                    xAxisPrePostGap: this.config.xAxisPrePostGap,
                    yAxisPrePostGap: this.config.yAxisPrePostGap
                  });
                }
                break;

              case "default":
                {
                  this.stacking("y");
                  this.applySublayout([{
                    x1: solver.attr(attrs, this.x1Name),
                    y1: solver.attr(attrs, this.y1Name),
                    x2: solver.attr(attrs, this.x2Name),
                    y2: solver.attr(attrs, this.y2Name),
                    group: state.dataRowIndices.map(function (x, i) {
                      return i;
                    })
                  }], "x", {
                    mode: "x-only"
                  });
                }
                break;

              case "numerical":
                {
                  // null, numerical
                  this.numericalMapping("y");
                  this.applySublayout([{
                    x1: solver.attr(attrs, this.x1Name),
                    y1: solver.attr(attrs, this.y1Name),
                    x2: solver.attr(attrs, this.x2Name),
                    y2: solver.attr(attrs, this.y2Name),
                    group: state.dataRowIndices.map(function (x, i) {
                      return i;
                    })
                  }], "x", {
                    mode: "x-only"
                  });
                }
                break;

              case "categorical":
                {
                  // null, categorical
                  this.categoricalMapping("y", {
                    mode: "default"
                  });
                }
                break;
            }
          }
          break;

        case "default":
          {
            switch (yMode) {
              case "null":
                {
                  this.stacking("x");
                  this.applySublayout([{
                    x1: solver.attr(attrs, this.x1Name),
                    y1: solver.attr(attrs, this.y1Name),
                    x2: solver.attr(attrs, this.x2Name),
                    y2: solver.attr(attrs, this.y2Name),
                    group: state.dataRowIndices.map(function (x, i) {
                      return i;
                    })
                  }], "y", {
                    mode: "y-only"
                  });
                }
                break;

              case "default":
                {
                  this.stacking("x");
                  this.stacking("y");
                }
                break;

              case "numerical":
                {
                  this.stacking("x");
                  this.numericalMapping("y");
                }
                break;

              case "categorical":
                {
                  this.stacking("x");
                  this.categoricalMapping("y", {
                    mode: "disabled"
                  });
                }
                break;
            }
          }
          break;

        case "numerical":
          {
            switch (yMode) {
              case "null":
                {
                  // numerical, null
                  this.numericalMapping("x");
                  this.applySublayout([{
                    x1: solver.attr(attrs, this.x1Name),
                    y1: solver.attr(attrs, this.y1Name),
                    x2: solver.attr(attrs, this.x2Name),
                    y2: solver.attr(attrs, this.y2Name),
                    group: state.dataRowIndices.map(function (x, i) {
                      return i;
                    })
                  }], "y", {
                    mode: "y-only"
                  });
                }
                break;

              case "default":
                {
                  this.stacking("y");
                  this.numericalMapping("x");
                }
                break;

              case "numerical":
                {
                  // numerical, numerical
                  this.numericalMapping("x");
                  this.numericalMapping("y");
                }
                break;

              case "categorical":
                {
                  // numerical, categorical
                  this.numericalMapping("x");
                  this.categoricalMapping("y", {
                    mode: "y-only"
                  });
                }
                break;
            }
          }
          break;

        case "categorical":
          {
            switch (yMode) {
              case "null":
                {
                  this.categoricalMapping("x", {
                    mode: "default"
                  });
                }
                break;

              case "default":
                {
                  this.stacking("y");
                  this.categoricalMapping("x", {
                    mode: "disabled"
                  });
                }
                break;

              case "numerical":
                {
                  this.numericalMapping("y");
                  this.categoricalMapping("x", {
                    mode: "x-only"
                  });
                }
                break;

              case "categorical":
                {
                  this.categoricalMapping("xy", {
                    mode: "default"
                  });
                }
                break;
            }
          }
          break;
      }

      solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(attrs, "x"), solver.attr(attrs, this.x1Name));
      solver.addEquals(solver_1.ConstraintStrength.HARD, solver.attr(attrs, "y"), solver.attr(attrs, this.y1Name));
    }
  }, {
    key: "applicableSublayoutOptions",
    value: function applicableSublayoutOptions() {
      var overlapOption = {
        value: "overlap",
        label: this.terminology.overlap,
        icon: this.terminology.overlapIcon
      };
      var packingOption = {
        value: "packing",
        label: this.terminology.packing,
        icon: this.terminology.packingIcon
      };
      var dodgeXOption = {
        value: "dodge-x",
        label: this.terminology.dodgeX,
        icon: this.terminology.dodgeXIcon
      };
      var dodgeYOption = {
        value: "dodge-y",
        label: this.terminology.dodgeY,
        icon: this.terminology.dodgeYIcon
      };
      var gridOption = {
        value: "grid",
        label: this.terminology.grid,
        icon: this.terminology.gridIcon
      };
      var props = this.plotSegment.object.properties;
      var xMode = props.xData ? props.xData.type : "null";
      var yMode = props.yData ? props.yData.type : "null";

      if ((xMode == "null" || xMode == "categorical") && (yMode == "null" || yMode == "categorical")) {
        return [overlapOption, dodgeXOption, dodgeYOption, gridOption, packingOption];
      }

      return [overlapOption, packingOption];
    }
  }, {
    key: "isSublayoutApplicable",
    value: function isSublayoutApplicable() {
      var props = this.plotSegment.object.properties;
      var xMode = props.xData ? props.xData.type : "null";
      var yMode = props.yData ? props.yData.type : "null"; // Sublayout is not applicable when one of x, y is scaffold ("default"), or both of them are numerical

      return xMode != "default" && yMode != "default" && (xMode != "numerical" || yMode != "numerical");
    }
  }, {
    key: "buildSublayoutWidgets",
    value: function buildSublayoutWidgets(m) {
      var extra = [];
      var props = this.plotSegment.object.properties;
      var type = props.sublayout.type;

      if (type == "dodge-x" || type == "dodge-y" || type == "grid" || type == "overlap") {
        var isXFixed = props.xData && props.xData.type == "numerical";
        var isYFixed = props.yData && props.yData.type == "numerical";
        extra.push(m.row("Align", m.horizontal([0, 0], isXFixed ? null : m.inputSelect({
          property: "sublayout",
          field: ["align", "x"]
        }, {
          type: "radio",
          options: ["start", "middle", "end"],
          icons: ["align/left", "align/x-middle", "align/right"],
          labels: ["Left", "Middle", "Right"]
        }), isYFixed ? null : m.inputSelect({
          property: "sublayout",
          field: ["align", "y"]
        }, {
          type: "radio",
          options: ["start", "middle", "end"],
          icons: ["align/bottom", "align/y-middle", "align/top"],
          labels: ["Bottom", "Middle", "Top"]
        }))));

        if (type == "grid") {
          extra.push(m.row("Gap", m.horizontal([0, 1, 0, 1], m.label("x: "), m.inputNumber({
            property: "sublayout",
            field: "ratioX"
          }, {
            minimum: 0,
            maximum: 1,
            percentage: true,
            showSlider: true
          }), m.label("y: "), m.inputNumber({
            property: "sublayout",
            field: "ratioY"
          }, {
            minimum: 0,
            maximum: 1,
            percentage: true,
            showSlider: true
          }))));
        } else {
          extra.push(m.row("Gap", m.inputNumber({
            property: "sublayout",
            field: type == "dodge-x" ? "ratioX" : "ratioY"
          }, {
            minimum: 0,
            maximum: 1,
            percentage: true,
            showSlider: true
          })));
        }

        if (type == "grid") {
          extra.push(m.row("Direction", m.horizontal([0, 0, 1], m.inputSelect({
            property: "sublayout",
            field: ["grid", "direction"]
          }, {
            type: "radio",
            options: ["x", "y"],
            icons: ["scaffold/xwrap", "scaffold/ywrap"],
            labels: [this.terminology.gridDirectionX, this.terminology.gridDirectionY]
          }), m.label("Count:"), m.inputNumber({
            property: "sublayout",
            field: props.sublayout.grid.direction == "x" ? ["grid", "xCount"] : ["grid", "yCount"]
          }))));
        }

        if (type != "overlap") {
          extra.push(m.row("Order", m.horizontal([0, 0], m.orderByWidget({
            property: "sublayout",
            field: "order"
          }, {
            table: this.plotSegment.object.table
          }), m.inputBoolean({
            property: "sublayout",
            field: "orderReversed"
          }, {
            type: "highlight",
            icon: "general/order-reversed"
          }))));
        }
      }

      var options = this.applicableSublayoutOptions();
      return [m.sectionHeader("Sub-layout"), m.row("Type", m.inputSelect({
        property: "sublayout",
        field: "type"
      }, {
        type: "radio",
        options: options.map(function (x) {
          return x.value;
        }),
        icons: options.map(function (x) {
          return x.icon;
        }),
        labels: options.map(function (x) {
          return x.label;
        })
      }))].concat(extra);
    }
  }, {
    key: "buildAxisWidgets",
    value: function buildAxisWidgets(m, axisName, axis) {
      var props = this.plotSegment.object.properties;
      var data = axis == "x" ? props.xData : props.yData;
      var axisProperty = axis == "x" ? "xData" : "yData";
      return axis_1.buildAxisWidgets(data, axisProperty, m, axisName);
    }
  }, {
    key: "buildPanelWidgets",
    value: function buildPanelWidgets(m) {
      if (this.isSublayoutApplicable()) {
        return [].concat(_toConsumableArray(this.buildAxisWidgets(m, this.terminology.xAxis, "x")), _toConsumableArray(this.buildAxisWidgets(m, this.terminology.yAxis, "y")), _toConsumableArray(this.buildSublayoutWidgets(m)));
      } else {
        return [].concat(_toConsumableArray(this.buildAxisWidgets(m, this.terminology.xAxis, "x")), _toConsumableArray(this.buildAxisWidgets(m, this.terminology.yAxis, "y")));
      }
    }
  }, {
    key: "buildPopupWidgets",
    value: function buildPopupWidgets(m) {
      var props = this.plotSegment.object.properties;
      var sublayout = [];

      if (this.isSublayoutApplicable()) {
        var extra = [];
        var isXFixed = props.xData && props.xData.type == "numerical";
        var isYFixed = props.yData && props.yData.type == "numerical";
        var type = props.sublayout.type;

        if (type == "dodge-x" || type == "dodge-y" || type == "grid" || type == "overlap") {
          if (!isXFixed) {
            extra.push(m.inputSelect({
              property: "sublayout",
              field: ["align", "x"]
            }, {
              type: "dropdown",
              options: ["start", "middle", "end"],
              icons: [this.terminology.xMinIcon, this.terminology.xMiddleIcon, this.terminology.xMaxIcon],
              labels: [this.terminology.xMin, this.terminology.xMiddle, this.terminology.xMax]
            }));
          }

          if (!isYFixed) {
            extra.push(m.inputSelect({
              property: "sublayout",
              field: ["align", "y"]
            }, {
              type: "dropdown",
              options: ["start", "middle", "end"],
              icons: [this.terminology.yMinIcon, this.terminology.yMiddleIcon, this.terminology.yMaxIcon],
              labels: [this.terminology.yMin, this.terminology.yMiddle, this.terminology.yMax]
            }));
          }

          if (type == "grid") {
            extra.push(m.inputSelect({
              property: "sublayout",
              field: ["grid", "direction"]
            }, {
              type: "dropdown",
              options: ["x", "y"],
              icons: ["scaffold/xwrap", "scaffold/ywrap"],
              labels: [this.terminology.gridDirectionX, this.terminology.gridDirectionY]
            }));
          }

          if (type != "overlap") {
            extra.push(m.sep());
            extra.push(m.orderByWidget({
              property: "sublayout",
              field: "order"
            }, {
              table: this.plotSegment.object.table
            }), m.inputBoolean({
              property: "sublayout",
              field: "orderReversed"
            }, {
              type: "highlight",
              icon: "general/order-reversed"
            }));
          }
        }

        var options = this.applicableSublayoutOptions();
        sublayout = [m.inputSelect({
          property: "sublayout",
          field: "type"
        }, {
          type: "dropdown",
          options: options.map(function (x) {
            return x.value;
          }),
          icons: options.map(function (x) {
            return x.icon;
          }),
          labels: options.map(function (x) {
            return x.label;
          })
        })].concat(extra);
      }

      var isXStacking = props.xData && props.xData.type == "default";
      var isYStacking = props.yData && props.yData.type == "default";

      if (isXStacking && !isYStacking) {
        if (props.xData.type == "default") {
          sublayout.push(m.label(this.terminology.xAxis + ": Stacking"));
        }

        sublayout.push(m.inputSelect({
          property: "sublayout",
          field: ["align", "y"]
        }, {
          type: "dropdown",
          options: ["start", "middle", "end"],
          icons: [this.terminology.yMinIcon, this.terminology.yMiddleIcon, this.terminology.yMaxIcon],
          labels: [this.terminology.yMin, this.terminology.yMiddle, this.terminology.yMax]
        }));
      }

      if (isYStacking && !isXStacking) {
        if (props.yData.type == "default") {
          sublayout.push(m.label(this.terminology.yAxis + ": Stacking"));
        }

        sublayout.push(m.inputSelect({
          property: "sublayout",
          field: ["align", "x"]
        }, {
          type: "dropdown",
          options: ["start", "middle", "end"],
          icons: [this.terminology.xMinIcon, this.terminology.xMiddleIcon, this.terminology.xMaxIcon],
          labels: [this.terminology.xMin, this.terminology.xMiddle, this.terminology.xMax]
        }));
      }

      if (isXStacking && isYStacking) {
        if (props.yData.type == "default") {
          sublayout.push(m.label(this.terminology.xAxis + " & " + this.terminology.yAxis + ": Stacking"));
        }
      }

      return _toConsumableArray(sublayout);
    }
  }]);

  return Region2DConstraintBuilder;
}();

exports.Region2DConstraintBuilder = Region2DConstraintBuilder;